module.exports = __webpack_public_path__ + "img/minicertificate.a10f5d57.svg";